module.exports = __webpack_public_path__ + "static/media/33_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_2_5_ccsa_y_ccso.497e2ed6.png";